<template>
  <modal 
    :show.sync="show"
    modal-classes="modal-dialog-centered modal-login"
    @close="close">
    <div 
      slot="base-content" 
      class="card card-plain card-login mb-0">
      <div class="modal-header justify-content-center">
        <button 
          type="button" 
          class="btn-sm close text-dark" 
          data-dismiss="modal" 
          aria-hidden="true"
          @click="close">
          <i class="now-ui-icons ui-1_simple-remove"/>
        </button>
        <div class="header header-primary text-center">
          <h4 class="font-weight-bold m-0">Change Password</h4>
        </div>
      </div>
      <ValidationObserver 
        v-slot="{ handleSubmit }" 
        ref="passwordForm">
        <form 
          class="form"
          @submit.prevent="handleSubmit(savePassword)">
          <div class="modal-body py-0">
            <div class="card-body">
              <ValidationProvider 
                name="Password" 
                rules="required|min:6"
                vid="confirmation">
                <div slot-scope="{ errors }">
                  <label>Password</label>
                  <fg-input 
                    :value="password" 
                    :error="errors[0]"
                    type="password"
                    addon-left-icon="now-ui-icons ui-1_lock-circle-open"
                    placeholder="Password"
                    @input="password=$event.target.value"/>
                </div>
              </ValidationProvider>
              <ValidationProvider 
                name="Confirm Password" 
                rules="required|confirmed:confirmation">
                <div slot-scope="{ errors }">
                  <label>Confirm Password</label>
                  <fg-input 
                    :value="cpassword" 
                    :error="errors[0]"
                    type="password"
                    addon-left-icon="now-ui-icons ui-1_lock-circle-open"
                    placeholder="Confirm Password"
                    @input="cpassword=$event.target.value"/>
                </div>
              </ValidationProvider>
              <div 
                v-if="status !== -1"
                class="alert alert-danger mb-0" 
                role="alert">
                Something went wrong!
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <n-button
              :disabled="loading" 
              native-type="submit"
              type="success" 
              round 
              class="w-100">
              {{ loading ? '' : 'Save' }}
              <i 
                v-if="loading" 
                class="bx bx-loader bx-spin"/>
            </n-button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </modal>
</template>
<script>
  import axios from 'axios';
  import { mapState, mapMutations } from 'vuex';
  import { Button, FormGroupInput, Modal } from '@/components';

  export default {
    components: {
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput,
      Modal
    },
    props: {
      open: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        show: false,
        password: '',
        cpassword: '',
        loading: false,
        status: -1
      };
    },
    watch: {
      open() {
        this.show = this.open;
      }
    },
    methods: {
      close() {
        this.password='';
        this.cpassword='';
        this.$refs.passwordForm.reset();
        this.status = -1;
        this.$emit('close');
      },
      savePassword() {
        this.loading = true;
        this.status = -1;
        axios.put('member/password', {
          password: this.password
        }).then(res => {
          this.loading = false;
          this.close();
        }).catch(err => {
          console.error('member/password: ', err.response);
          this.status = err.response.status;
          this.loading = false;
        })        
      }
    }
  }
</script>
<style lang='scss' scoped>
  ::v-deep .modal-login {
    max-width: 360px !important;
    
    @media (max-width: 576px) {
      max-width: 320px !important;
      margin-left: auto;
      margin-right: auto;
    }

    .modal-header {
      .logo-container {
        margin-bottom: 0 !important;
      }
    }

    .modal-footer {
      display: block;
    }
  }
</style>
